<script>
import Asset from '@/components/asset/AssetForm.vue';
export default {
components: {
    Asset
    },
}
</script>

<template>
    <Asset/>
</template>